import type * as Scrivito from "scrivito";

export const urlFromBinary = (
  binary: Scrivito.Obj | Scrivito.Obj[] | null | undefined,
): string | null => {
  if (!binary || (binary as Scrivito.Obj[]).length === 0) {
    return null;
  }

  const blob = (binary as Scrivito.Obj).get("blob") as Scrivito.Binary | null;
  if (!blob) {
    return null;
  }

  return blob.url() || null;
};
